import { AutoSizer, List } from 'react-virtualized';

export default {
  AutoSizer,
  List,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/virtualized.js